package components.login

import components.OnlineStateBanner
import kotlinx.css.*
import react.*
import react.dom.*
import router.useDocumentTitle
import styled.*

/**
 * The login page - shows only the login form
 */
val LoginPage: FC<Props> = fc("LoginPage") {
  useDocumentTitle("", "Login")

  div("text-center") {
    styledDiv {
      css {
        width = 100.pct
        maxWidth = 330.px
        padding = Padding(15.px)
        margin = Margin(LinearDimension.auto, LinearDimension.auto)
      }

      OnlineStateBanner {}

      div("py-5 text-center") {
        div("container") {
          LoginForm {}
        }
      }
    }
  }

}
